import React from "react";
import { motion } from "framer-motion";
import "../../styles/ContactSerene.css";
import bgImage from "../../assets/woods-images/contact-bg-woods.jpg";
import ContactFormContainer from "../ContactFormContainer";

export default function ContactWoods() {
  const cardStagger = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.06,
        delayChildren: 0.04,
      },
    },
  };

  const fadeUp = {
    hidden: { opacity: 0, y: 45, filter: "blur(10px)" },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: 0.45, ease: "easeOut" },
    },
  };

  const wordContainer = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.04,
        delayChildren: 0.06,
      },
    },
  };

  const wordVariant = {
    hidden: { y: 35, opacity: 0, filter: "blur(6px)" },
    show: {
      y: 0,
      opacity: 1,
      filter: "blur(0px)",
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  return (
    <section id="serene-contact" className="contact-serene">
      <div
        className="contact-bg"
        style={{ backgroundImage: `url(${bgImage})` }}
      ></div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <motion.div
              className="contact-card text-white rounded-3 p-4 p-md-5"
              variants={cardStagger}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.6 }}
            >
              <ContactFormContainer
                variant="cyber-meadows"
                fadeUp={fadeUp}
                wordContainer={wordContainer}
                wordVariant={wordVariant}
              />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
